export default __webpack_public_path__ + "static/media/choice-icon.31dcd677.svg";